import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Work Sans", sans-serif;
  }


html {
  font-size: 62.5%;
  /* scroll-behavior: smooth; */
  /* 1rem = 10px */
  overflow-x: hidden;
  }

body {
  overflow-x: hidden;
  scrollbar-color: rgb(98 84 243);
  scrollbar-width: thin;
  }

body::-webkit-scrollbar {
  width: 1.5rem;
  }

body::-webkit-scrollbar-track {
   background-color: rgb(24 24 29);
   }

body::-webkit-scrollbar-thumb {
  background: #fff;
  border: 5px solid transparent;
  border-radius: 9px;
  background-clip: content-box;
  }

h1,
h2,
h3,
h4 {
   font-family: "Work Sans", sans-serif;
   }

 h1 {
  color: ${({ theme }) => theme.colors.heading};
  font-size: 6rem;
  font-weight: 900;
  }

 h2 {
   color: ${({ theme }) => theme.colors.font};
   font-size: 4.4rem;
   font-weight: 300;
   white-space: normal;
  }

 h3{
  font-size: 1.8rem;
  font-weight: 400;
  }

p, button {
  color: ${({ theme }) => theme.colors.text};
  font-size: 1.65rem;
  line-height: 1.5;
  font-weight:400;
  }

a {
  text-decoration: none;
  }

li {
  list-style: none;
  }


${"" /* resuable code section  */}

.container {
  max-width: 120rem;
  margin: 0 auto;
  }

.main-container {
  display: flex;
  flex-direction: column;
  padding: 0 3rem;
 }


.grid {
  display: grid;
  gap: 9rem;
  }

.grid-two-column {
 grid-template-columns: repeat(2, 1fr);
 }

.grid-three-column {
 grid-template-columns: repeat(3, 1fr);
 }

.grid-four-column{
  grid-template-columns: 1fr 1.2fr .5fr .8fr ;
 }

.grid-five-column{
  grid-template-columns: repeat(5, 1fr);
}

.common-heading {
  font-size: 3.8rem;
  font-weight: 600;
  margin-bottom: 6rem;
  text-transform: capitalize;
  }

.intro-data {
  margin-bottom: 0;
  text-transform: uppercase;
  color: #5138ee;
  }

.caption {
  background-color: #fff;;
  color:  ${({ theme }) => theme.colors.font};
  position: absolute;
  top: 8%;
  right: 5%;
  text-transform: capitalize;
  font-weight: 500;
  padding: 0.8rem 1rem;
  font-size: 2rem;
  border-radius: 2rem;
  }

    
form {
  width: 100%;
  align-items: center;
  justify-content: center;
  }

label {
    display: flex;
    align-items: center;
    align-text: center;
    margin-top: 2rem;
    gap: 2rem;
    font-size: 12px;
    font-weight: bold;
    }

input, select {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    box-sizing: border-box;    
    border-radius: 4px;
    }

input:focus,
  select:focus {
  outline: none;
  border-color: #484949;
  box-shadow: 0 0 4px rgba(0,115,230,0.5);
}

input, textarea{
  max-width: 70rem;
  color: ${({ theme }) => theme.colors.black};
  padding: 1.3rem 2.2rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.colors.shadowSupport};
  border-radius: 0.7rem;
  }

svg {  
  font-size:3rem;
  padding: 0.3rem;
  align-items: center;
  justify-content: center;
  color:${({ theme }) => theme.colors.font};
  }

 
.two-button {
    margin-top: 2rem;
    display: flex;
    justify-content: space-between;

    .btn-two {
    background-color: rgba(253, 99, 99, 1);
    }
  }

    }

`;
